(() => {
  window.Varellea.register('collection-filters', root => {
    const panel = root.querySelector('[data-filter-panel]');
    const openButton = root.querySelector('[data-filter-open]');
    const closeButton = root.querySelector('[data-filter-close]');
    const scrim = root.querySelector('[data-filter-scrim]');
    const sort = root.querySelector('[data-sort-select]');
    const controller = new AbortController();
    let previousFocus, previousOverflow;
    const mobile = matchMedia('(max-width: 989px)');
    function close() {
      if (!panel || panel.dataset.open !== 'true') return;
      panel.dataset.open = 'false';
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      scrim.hidden = true;
      openButton?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previousOverflow || '';
      (previousFocus?.isConnected ? previousFocus : openButton)?.focus();
    }
    function open() {
      if (!panel || !mobile.matches) return;
      previousFocus = document.activeElement;
      panel.dataset.open = 'true';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      scrim.hidden = false;
      openButton?.setAttribute('aria-expanded', 'true');
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      closeButton?.focus();
    }
    function onKeydown(event) {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab' || panel?.dataset.open !== 'true') return;
      const focusable = [...panel.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), summary')].filter(item => item.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    function onBreakpoint() { if (!mobile.matches) close(); }
    return {
      connect() {
        root.classList.add('v-collection--enhanced');
        openButton?.addEventListener('click', open, { signal: controller.signal });
        closeButton?.addEventListener('click', close, { signal: controller.signal });
        scrim?.addEventListener('click', close, { signal: controller.signal });
        sort?.addEventListener('change', () => sort.form?.requestSubmit(), { signal: controller.signal });
        document.addEventListener('keydown', onKeydown, { signal: controller.signal });
        mobile.addEventListener('change', onBreakpoint, { signal: controller.signal });
      },
      disconnect() { close(); controller.abort(); root.classList.remove('v-collection--enhanced'); }
    };
  });
})();
